import { actionTypesEnum } from '../enum';

export default (state = null, action) => {

  if (action.type === actionTypesEnum.getFacturaPorEmisor) {
    return action.payload;
  }

  return state;
}

export const getFacturaCompraPorEmisor = (state = null, action) => {

  if (action.type === actionTypesEnum.getFacturaCompraPorEmisor) {
    return action.payload;
  }

  return state;
}

export const duplicarFactura = (state = null, action) => {

  if (action.type === actionTypesEnum.duplicarFactura) {
    return action.payload;
  }

  return state;
};

export const direccionEmisor = (state = null, action) => {

  if (action.type === actionTypesEnum.direccionEmisor) {
    return action.payload;
  }

  return state;
};

export const direccionReceptor = (state = null, action) => {

  if (action.type === actionTypesEnum.direccionReceptor) {
    return action.payload;
  }

  return state;
};


export const estadoDocumentoElectronico = (state = null, action) => {

  if (action.type === actionTypesEnum.estadoDocumentoElectronico) {
    return action.payload;
  }

  return state;
};
export const getDocumentosConfirmados = (state = null, action) => {

  if (action.type === actionTypesEnum.getDocumentosConfirmados) {
    return action.payload;
  }
  return state;

}

export const confirmacionFacturas = (state = null, action) => {

  if (action.type === actionTypesEnum.confirmacionFacturas) {
    return action.payload;
  }
  return state;
}
